import { render } from "./ToolbarBookmarkIcon.vue?vue&type=template&id=5b1bca04"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__